import { render } from "./QuickLinksRail.vue?vue&type=template&id=581f5c08&scoped=true"
import script from "./QuickLinksRail.vue?vue&type=script&lang=js"
export * from "./QuickLinksRail.vue?vue&type=script&lang=js"

import "./QuickLinksRail.vue?vue&type=style&index=0&id=581f5c08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581f5c08"]])

export default __exports__